import React, { Component } from "react"
import { connect } from "react-redux"
import styles from "./styles.css"
import Card from "../../components/Card"
import Button from "react-toolbox/lib/button/Button"
import { withActions } from "../../utils"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import * as strings from "../../strings"
import { toastr } from "react-redux-toastr"
import Stepper from "react-stepper-horizontal"
import Validate from "./Validate"
import PickDebtPhases from "./PickDebtPhases"
import Details from "./Details"

const STEPS = [
  { title: strings.billingOrders.CreateSteps.billingOrderDetails },
  { title: strings.billingOrders.CreateSteps.pickProcesses },
  { title: strings.billingOrders.CreateSteps.validate },
]

class CreateBillingOrder extends Component {
  props: {
    history: any,
    actions: any,
  }

  state = {
    step: 0,
    billingOrder: {
      segment: null,
    },
  }

  renderHeader ( step ) {
    return (
      <Card className={styles.stepperCard}>
        <div className={styles.stepper}>
          <Stepper
            steps={STEPS}
            activeStep={step}
          />
        </div>
      </Card>
    )
  }

  renderStep ( step ) {
    const stepComponents = [
      Details,
      PickDebtPhases,
      Validate,
    ]

    const stepOnChange = newValue => this.setState( {
      billingOrder: newValue,
    } )
    const renderComponent = stepComponents[ step ]

    // Should never happen
    if ( !renderComponent ) {
      return null
    }

    return React.createElement( renderComponent, {
      value: this.state.billingOrder,
      onChange: stepOnChange,
    } )
  }

  canStepForward = () => {
    const { step } = this.state
    const STEP_FORWARD_FN = [
      ( bo => bo.clientName && bo.debtPhase && bo.billingPhase ),
      ( bo => bo.debtPhases && bo.debtPhases.length > 0 ),
      ( () => true ),
    ]
    const stepFn = STEP_FORWARD_FN[ step ]

    return stepFn( this.state.billingOrder )
  }

  createBillingOrder = () => {
    const { billingOrder } = this.state
    const expenseIds = _.chain( billingOrder.debtPhases )
      .flatMap( debtPhase => debtPhase.expenses )
      .map( expense => expense.id )
      .value()

    const preparedBillingOrder = _.pick( {
      ...billingOrder,
      expenseIds,
    }, [ "billingPhase", "debtPhase", "segment", "clientName", "expenseIds" ] )

    this.props.actions.createBillingOrder( preparedBillingOrder )
      .then( () => toastr.success( strings.billingOrders.billingOrderCreated ) )
      .then( () => this.props.history.goBack() )
      .catch( () => toastr.error( strings.billingOrders.errorCreatingBillingOrder ) )
  }

  advanceStep = () => {
    const step = this.state.step
    const isLastStep = step === ( STEPS.length - 1 )

    if ( isLastStep ) {
      this.createBillingOrder()
    } else {
      this.setState( {
        step: Math.min( step + 1, ( STEPS.length - 1 ) ),
      } )
    }
  }

  previousStep = () => {
    const step = this.state.step
    this.setState( {
      step: Math.max( step - 1, 0 ),
    } )
  }

  renderFooter ( step ) {
    const isFirstStep = step === 0
    const isLastStep = step === ( STEPS.length - 1 )
    const cancel = () => this.props.history.goBack()

    return (
      <div className={styles.footer}>
        <Button
          onClick={cancel}
          label={strings.generalStrings.cancel}
          flat
        />
        <Button
          onClick={this.previousStep}
          label={strings.generalStrings.return}
          disabled={isFirstStep}
        />
        <Button
          onClick={this.advanceStep}
          label={isLastStep
            ? strings.generalStrings.submit
            : strings.generalStrings.next}
          disabled={!this.canStepForward()}
          flat
        />
      </div>
    )
  }

  render () {
    const step = this.state.step
    return (
      <div className={styles.root}>
        {this.renderHeader( step )}
        {this.renderStep( step )}
        {this.renderFooter( step )}
      </div>
    )
  }
}

export default connect(
  store => _.pick( store, [ "billingOrders" ] )
)( withActions( withRouter( CreateBillingOrder ) ) )



// WEBPACK FOOTER //
// ./src/views/CreateBillingOrder/index.jsx